<style scoped lang="scss">
.donation-button {
    position: relative;

    .close {
        position: absolute;
        top: 1rem;
        right: 3rem;
        z-index: 9999999;
        font-size: 1.5rem;
    }
}
</style>
<template>
    <div>
        <modal ref="donation-button" class="donation-button" v-slot="slotProps" :showFooter="false" :showHeader="false">
            <button type="button" class="close" @click="slotProps.close()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>

            <slot></slot>
        </modal>
    </div>
</template>

<script>
    export default {
        mounted() {
            this.$root.$on('donate', () => {
                this.show();
            });

            if (this.getCookie('make-donation')) {
                this.show();
            }
        },

        methods: {

            show() {
                const modal = this.$refs['donation-button'];
                if (modal) {
                    modal.show();
                }
            },

            getCookie(name) {
                const nameEQ = name + "=";
                const ca = document.cookie.split(';');
                for(let i=0;i < ca.length;i++) {
                    let c = ca[i];
                    while (c.charAt(0)==' ') c = c.substring(1,c.length);
                    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
                }
                return null;
            },
        }
    }
</script>
